import { render, staticRenderFns } from "./SelectArchetypeByAlias.vue?vue&type=template&id=30b35082&"
import script from "./SelectArchetypeByAlias.vue?vue&type=script&lang=js&"
export * from "./SelectArchetypeByAlias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports